import { useEffect } from 'react';
import { SESSION_EXPIRED_EVENT } from '../utils/authEvents';

/**
 * Listens for the session-expired event triggered by the Axios interceptor
 * and immediately logs the user out and redirects to the login page, rather
 * than waiting for the user to acknowledge a dialog. A short notice is left
 * for the login page to display.
 */
const SessionExpiredDialog = () => {
    useEffect(() => {
        const handleSessionExpired = () => {
            localStorage.removeItem('currentUser');
            sessionStorage.setItem('loginNotice', 'Your session has timed out due to inactivity. Please log in again.');

            // FORCE RELOAD: window.location will wipe all React state (including isAuth)
            // and loads the login page fresh.
            window.location.href = '/login';
        };

        // Listen for the event triggered by the Axios interceptor
        window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);

        // Cleanup
        return () => {
            window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
        };
    }, []);

    return null;
};

export default SessionExpiredDialog;
